<template>
  <div>
    <v-btn
      small
      class="ml-0 mt-0"
      color="success"
      :loading="uploading"
      @click="pickFile()"
      >Upload Files<v-icon right small>mdi-cloud-upload</v-icon></v-btn
    >
    <input
      type="file"
      multiple
      style="display: none"
      ref="files"
      @change="onFilePicked($event)"
    />
    <v-layout row wrap class="mt-1">
      <div
        v-for="(file, index) in files"
        :key="index"
        style="border: 1px solid #4caf50; border-radius: 5px; width: 190px; background-color: #f0f0f0;"
        class="ma-2"
      >
        <v-layout row justify-space-between class="px-2 py-1">
          {{ truncateText(file.name, 15) }}
          <v-icon title="Remove file" flat small @click="removeFile(index)">mdi-close-circle</v-icon>
        </v-layout>
      </div>
    </v-layout>
  </div>
</template>

<script>
import { truncate } from "../../utils/helpers.js";

export default {
  props: {
    uploadUrl: {
      type: String,
      required: true,
    },
    files: {
      type: Array,
      default: () => [],
    },
    uploading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    pickFile() {
      this.$refs.files.click();
    },
    async onFilePicked(e) {
      this.$emit("update:uploading", true);
      const files = e.target.files;
      if (!files) return;
      try {
        const newFiles = [...this.files];
        for (var i = 0; i < files.length; i++) {
          var formData = new FormData();
          formData.append("file", files[i]);
          const response = await this.$http.post(this.uploadUrl, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
          newFiles.push(response.files[0]);
        }
        this.$emit("update:files", newFiles);
        this.$emit("update:uploading", false);
        this.$refs.files.value = null;
      } catch (e) {
        this.$emit("update:uploading", false);
      }
    },
    removeFile(index) {
      const newFiles = [...this.files];
      newFiles.splice(index, 1);
      this.$emit("update:files", newFiles);
    },
    reset() {
      this.$emit("update:files", []);
      this.$emit("update:uploading", false);
      this.$refs.files.value = null;
    },
    truncateText(text, count) {
      return truncate(text, count);
    },
  },
};
</script>
